<template>
  <div style="margin-bottom: 170px">
    <!-- Tab -->
    <BuTab></BuTab>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="px-5 pt-5 py-10px d-flex">
        <div class="form-input-group w-702px mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getFaqs">搜尋</button>
      </div>
      <!-- seconad bar -->
      <div class="d-flex px-5 pb-5">
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選產品分類"
          modalWidth="200px"
          :isOnlyShowButtonPlaceholder="true"
          :options="categoryOptions"
          :selectedValue.sync="filter.productCategoryId"
          item-value="id"
          item-text="name"
        >
        </SimpleSelectWithSearchInput>
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選產品型號"
          modalWidth="200px"
          :isOnlyShowButtonPlaceholder="true"
          :options="productOptions"
          :selectedValue.sync="filter.productId"
          item-value="id"
          item-text="model_name"
        >
        </SimpleSelectWithSearchInput>
        <SegmentalControls
          class="mr-2"
          :buttons="generalOptions"
          v-model="filter.popularcfg"
          itemStyle="style-basic"
        ></SegmentalControls>
      </div>
      <!-- filter condition -->
      <div
        class="px-5 mb-5 d-flex"
        v-if="
          filter.productCategoryId != null ||
          filter.productId != null
        "
      >
        <div
          class="h5 ink-02-medium--text h-32px w-70px d-flex align-center flex-shrink-0"
        >
          篩選條件：
        </div>
        <div class="flex-wrap">
          <!-- filter category -->
          <v-chip
            v-if="filter.productCategoryId != null"
            close
            class="ml-5 mb-2"
            @click:close="filter.productCategoryId = null"
          >
            {{ categoryName }}
          </v-chip>
          <!-- filter Model Name -->
          <v-chip
            v-if="filter.productId != null"
            close
            class="ml-5 mb-2"
            @click:close="filter.productId = null"
          >
            {{ productName }}
          </v-chip>
        </div>
      </div>

      <!-- table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <div v-if="lengthOfisCheckedList > 0"
               class="form-item d-flex align-center px-5 h-60px batch">
              <h5 class="col-checkbox">
                <v-checkbox
                  v-model="checkAllStatus"
                  :indeterminate="indeterminate"
                  @click="changeAllCheckbox"
                ></v-checkbox>
              </h5>
              <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
              <div>
                <button class="btn btn-danger mr-10px" @click="multiDelete">
                  <v-icon color="white" class="mr-2">delete</v-icon>
                  <span>刪除</span>
                </button>
              </div>
              <div>
                <button class="btn mr-10px" @click="multiChangeStatus(true)">設為顯示</button>
              </div>
              <div>
                <button class="btn" @click="multiChangeStatus(false)">設為隱藏</button>
              </div>
            </div>
            <tr>
              <th>
                <v-checkbox
                  v-model="checkAllStatus"
                  :indeterminate="indeterminate"
                  @click="changeAllCheckbox"
                ></v-checkbox>
              </th>
              <th class="text-left">ID</th>
              <th class="text-left">Question</th>
              <th class="text-left">Order</th>
              <th class="text-left">BU</th>
              <th class="text-left">Category</th>
              <th class="text-left">顯示/隱藏</th>
              <th class="text-left">編輯</th>
              <th class="text-left">刪除</th>
            </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in faqs"
            :key="item.id"
          >
            <td>
              <v-checkbox v-model="item.isChecked"></v-checkbox>
            </td>
            <td>{{ item.id }}</td>
            <td>{{ item.question }}</td>
            <td>{{ item.order }}</td>
            <td>{{ item.bu.name }}</td>
            <td>{{ item.product_category.name }}</td>
            <td>
              <FormSwitch
                v-model="item.status"
                @changeStatus="toggleStatus(item.id)">
              </FormSwitch>
            </td>
            <td>
              <button class="btn square" @click="toSupportFaqEdit(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </td>
            <td>
              <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- table footer -->
      <Pagination @handleNextPreEvent="getFaqs" model="supportFaq"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import BuTab from '@/components/BuTab.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import SegmentalControls from '@/components/SegmentalControls.vue';

export default {
  components: {
    deleteDialog,
    SimpleSelectWithSearchInput,
    BuTab,
    Pagination,
    FormSwitch,
    SegmentalControls,
  },
  data: () => ({
    categoryOptions: [],
    productOptions: [],
    // filter
    checkAllStatus: false, // left top checkbox status
    // selectedItems
    selectedItems: [],
    generalOptions: [{
      value: 1,
      title: 'General',
    }, {
      value: 0,
      title: '不限',
    }],
  }),
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('supportFaq', ['faqs', 'filter']),
    lengthOfisCheckedList() {
      return this.faqs.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.faqs.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.faqs.filter((item) => item.isChecked).map((item) => item.id);
    },
    categoryName() {
      const category =
        this.categoryOptions.find((item) => item.id === this.filter.productCategoryId);
      return category ? category.name : '';
    },
    productName() {
      const product = this.productOptions.find((item) => item.id === this.filter.productId);
      return product ? product.model_name : '';
    },
  },
  async created() {
    this.categoryOptions = await this.allByBu(this.currentBuTabId);
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.faqs.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.faqs.length) {
        this.checkAllStatus = true;
      }
    },
    async currentBuTabId(newValue) {
      this.filter.buId = newValue;
      this.getFaqs();
      this.categoryOptions = await this.allByBu(newValue);
    },
    async 'filter.productCategoryId'(newValue) {
      this.filter.productId = null;
      if (newValue === null) {
        this.productOptions = [];
      } else {
        this.productOptions = await this.allByCategory(newValue);
      }
    },
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    ...mapActions('product', ['allByCategory']),
    ...mapActions('supportFaq', {
      getFaqs: 'find',
      destroyFaq: 'destroy',
      setFilter: 'setFilter',
      clear: 'clear',
      changeStatus: 'changeStatus',
    }),
    toSupportFaqEdit(id) {
      this.$router.push({
        name: 'SupportFaqEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.faqs.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.faqs.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyFaq(id).then(() => {
        this.getFaqs();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyFaq(id).then(() => {});
      });
      this.getFaqs();
    },
    async multiChangeStatus(status) {
      await this.isCheckedListIds.forEach((id) => {
        this.changeStatus({
          id, status,
        }).then(() => {});
      });
      this.getFaqs();
    },
    toggleStatus(id) {
      this.changeStatus({ id }).then(() => {
        this.getFaqs();
      });
    },
  },
};
</script>
<style lang="scss">
.table {
  .col-pic {
    width: 40px;
    margin-right: 20px;
  }
  .col-driver-type {
    min-width: 107px;
    margin-right: 10px;
  }
  .col-category {
    min-width: 92px;
    margin-right: 10px;
  }
  .col-modal-name {
    min-width: 170px;
    margin-right: 10px;
  }
  .col-driver-os {
    width: 95px;
    margin-right: 10px;
  }
  .col-driver-descript {
    width: 180px;
    margin-right: 10px;
  }
  .col-update-date {
    width: 84px;
    text-align: right;
  }
}
</style>
